import moment from 'moment'

import { formatDate } from '../../../../../utils/format'

export const getCurrentDate = (schema = 'HH:mm') => formatDate(moment(), schema);

export const formatEntryTime = (date) => formatDate(date, 'HH:mm');